'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BackButton = require('./components/BackButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BackButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/back-button/index.js
// module id = 916
// module chunks = 0